export default "__VITE_ASSET__Drv$wlIv__"